/**
 * Local Development Helper
 * Provides utilities to help with local development environment
 * These functions will only run in localhost environments and have no effect in production
 */

/**
 * Checks if the application is running in local development mode
 * @returns {boolean} True if running on localhost
 */
export const isLocalDevelopment = () => {
  return window.location.hostname === 'localhost';
};

/**
 * Creates a mock tenant for local development
 * This only runs in local development and has no effect in production
 */
export const setupLocalDevelopmentEnvironment = () => {
  if (!isLocalDevelopment()) return;

  // Check if we already have a tenant in localStorage
  const existingTenant = localStorage.getItem('selectedRestToolsTenant');

  if (!existingTenant) {
    console.log('Local development mode: Creating mock tenant for development');

    // Create a mock tenant
    const mockTenant = {
      id: 'local-dev-tenant-001',
      name: 'Local Development Tenant',
    };

    // Store it in localStorage
    localStorage.setItem('selectedRestToolsTenant', JSON.stringify(mockTenant));
    console.log('Mock tenant created:', mockTenant);
  }
};

export default {
  isLocalDevelopment,
  setupLocalDevelopmentEnvironment,
};
